// @ts-nocheck
import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { green } from "@mui/material/colors";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { onTextPropertyChange } from "../../utils/validation";
import whiteLogo from '../../assets/icons/white_logo.png';
import useOrganizationStore from '@store/organizationStore';
import { getAdminCookie } from '@/utils/clerk';
import { useUser, useAuth } from '@/auth/clerkShim';
import CreateLeagueRegistration from "@/components/CreateRegistration/CreateLeagueRegistration";
import CreateTournamentRegistration from "@/components/CreateRegistration/CreateTournamentRegistration";
import './index.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Create } from "@mui/icons-material";

function CreateTournamentRegistrationPage(props) {
  const { isSignedIn, user, isLoaded } = useUser();
  const { getToken } = useAuth();
  // const { getAdminByClerkId, admin } = useAdminStore();
  const admin = getAdminCookie();
  const [loading, setLoading] = useState(false);
  const [selectedSport, setSelectedSport] = useState('basketball');
  const [registration, setRegistration] = useState(true);
  const [registrationType, setRegistrationType] = useState('tournament');

  const SPORTS = [
    {name: 'Basketball', value: 'basketball' },
    {name: 'Baseball', value: 'baseball' },
    {name: 'Softball', value: 'softball' },
    {name: 'Baseball', value: 'baseball' },
    {name: 'Football', value: 'football' },
    {name: 'Soccer', value: 'soccer' },
    {name: 'Volleyball', value: 'volleyball' },
    {name: 'Pickleball', value: 'pickleball' },
    {name: 'Multiple Competitions', value: 'multiple competitions' },
    {name: 'Other', value: 'other' },

  ]

  console.log('CreateOrganizationRegistrationPage::user', user, isSignedIn, isLoaded);

  const submitRegistration = async () => {
    const { league } = admin;
    const token = await getToken();
  };

  // useEffect(() => {
  //   console.log('useEffect::user::', user);
  //   getAdmin(user.id);
  // }, [user]);

  console.log('CreateOrganizationBannerPage::admin', admin);

  return (
    <div className={'body'}>
      <Paper className={'main-container'} elevation={1}>
        <div className={'left-container'}>
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <img
              style={{ height: "35px", margin: "20px 10px 20px 0px" }}
              src={whiteLogo} alt="Staty" />
          </div>
          <div style={{ margin: "20px" }}>
            <Typography variant="subtitle1" style={{ color: "white" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
              ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
              deserunt mollit anim id est laborum.
            </Typography>
          </div>
        </div>
        <div className={'rightContainer'}>
          <Typography variant="h4" gutterBottom>
            CREATE LEAGUE REGISTRATION
          </Typography>
          <Divider variant="middle" />
          <div style={{ width: "100%", marginTop: "20px" }}>
            <Typography variant="subtitle1">Select Sport:</Typography>
              <FormControl component="fieldset" className={'formControl'}>
                <Select native onChange={(e) => setSelectedSport(e.target.value)}>
                  {SPORTS.map((sport, key) => {
                    return (
                      <option 
                        value={sport.value} 
                        key={sport.value} 
                        selected={selectedSport.value == sport.value}>
                          {sport.name}
                      </option>
                    );
                  })}
                </Select>
                <br />
                <Typography variant="subtitle1">Include Registration:</Typography>
                <RadioGroup
                  aria-label="registration"
                  name="registration"
                  className={'group'}
                  value={registration}
                  onClick={e => setRegistration(e.target.value)} >
                  <FormControlLabel  value={true} control={<Radio />} label={'Yes'} />
                  <FormControlLabel  value={false} control={<Radio />} label={'No'} />
                </RadioGroup>
                <br />
                <Typography variant="subtitle1">Type of Registration:</Typography>
                <RadioGroup
                  aria-label="registration"
                  name="registration"
                  className={'group'}
                  value={registrationType}
                  onClick={e => setRegistrationType(e.target.value)} >
                  <FormControlLabel  value={'season'} control={<Radio />} label={'Season'} />
                  <FormControlLabel  value={'tournament'} control={<Radio />} label={'Tournament'} />
                </RadioGroup>
              </FormControl>
              { registration && ( registrationType === 'season' ? (<CreateLeagueRegistration sport={selectedSport} />) : (<CreateTournamentRegistration sport={selectedSport} />))}
            </div>
          <div style={{ marginTop: "30px" }}>
            <div className={'wrapper'}>
              <Button variant="contained" onClick={submitRegistration} color="primary" disabled={loading}>
                Submit
              </Button>
              {loading && <CircularProgress size={24} className={'buttonProgress'} />}
            </div>
          </div>
        </div>
      </Paper>
    </div>
  );
}
export default CreateTournamentRegistrationPage;